module.exports = __webpack_public_path__ + "img/base_restauration_viande.87004655.svg";